<template>
  <templatePublicComponent>
    <div>
      <h3>Historique de la compagnie :</h3>
      <div class="content">
          <p>En 1994, Robert Bourdeau fonde la compagnie Robert Bourdeau inc.</p>
          <p>En 1997, les cousins de Robert Bourdeau, Roger et Marc Viau sous le nom de Déneigement R.M. Viau deviennent partenaire de déneigement Robert Bourdeau Inc.</p>
          <p>En 2010, Robert Bourdeau Inc. s'associe avec Yannic Létourneau sous le nouveau nom de compagnie qui deviendra alors Déneigement Bourdeau Létourneau Inc.</p>
          <p>En 2023,  Robert Bourdeau passe le flambeau à Yannic Létourneau qui devient l’unique propriétaire de la compagnie qui garde le nom déneigement Bourdeau Létourneau Inc.</p>
          <div style="text-align:center"><img width="550" src="@/assets/img/image_flotte.jpg"></div>
          <div style="margin-top:30px;">
            Nous tenons à remercier notre clientèle qui nous font confiance depuis le début ainsi qu’à tous ceux qui se joignent à nous et nous vous assurons du maintien constant de la qualité de nos services.
          </div>
        </div>
    </div>
  </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Sujet.vue